var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgArrowsRepeat(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M3.904 12.059v-.375C4.138 7.934 7.28 4.98 11.03 4.98H21.06l-2.578-2.578c-.468-.422-.468-1.125 0-1.593.422-.422 1.125-.422 1.594 0l4.5 4.5c.422.468.422 1.171 0 1.593l-4.5 4.5c-.469.47-1.172.47-1.594 0-.468-.421-.468-1.125 0-1.593L21.06 7.23H11.03c-2.579 0-4.735 2.016-4.876 4.594v.375c-.047.61-.61 1.078-1.219 1.031-.609 0-1.078-.562-1.03-1.171zm23.953.14h.047l-.047.375c-.234 3.75-3.328 6.656-7.125 6.656H10.701l2.578 2.579c.469.468.469 1.171 0 1.593a1.027 1.027 0 01-1.547 0l-4.5-4.5c-.469-.422-.469-1.125 0-1.593l4.5-4.454a1.027 1.027 0 011.547 0 1.026 1.026 0 010 1.547l-2.578 2.579h10.031c2.578 0 4.735-1.97 4.875-4.547l.047-.375c0-.61.563-1.079 1.172-1.079.61.047 1.078.61 1.031 1.22z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgArrowsRepeat);
export default ForwardRef;
